import React from 'react';
import { useNavigate } from 'react-router';

import { TermsAndPrivacyLinks } from '@hcs/auth';
import { Card } from '@hcs/design-system';
import { APP_CONFIG_MARKET_INSIGHTS } from '@hcs/hc-products';
import { SelfServiceConfirmAccount } from '@hcs/self-service';

import styles from './MiSelfServiceSetupPage.module.css';

const dataHcName = 'mi-self-setup-page';
export const MiSelfServiceSetupPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Card dataHcName={dataHcName} className={styles.Card}>
        <SelfServiceConfirmAccount
          onGetStarted={() => navigate(APP_CONFIG_MARKET_INSIGHTS.rootPath)}
        />
      </Card>
      <TermsAndPrivacyLinks />
    </>
  );
};
